import React, { memo } from "react";
import PropTypes from "prop-types";
import { Stack, Button, Icon } from "investira.react.components";

/**
 * Renderiza o componente ArquivosContextActions.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {boolean} props.disabled - Propriedade `disabled` do componente.
 * @param {Function} props.onUploadClick - Propriedade `onUploadClick` do componente.
 *
 * @description
 * Este componente realiza as seguintes operacoes:
 * 1. Recebe as propriedades necessarias para compor a interface
 * 2. Organiza os estados e callbacks usados durante a renderizacao
 * 3. Renderiza a experiencia visual do organismo
 *
 * @returns {JSX.Element|null} Elemento renderizado pelo componente.
 */

const ArquivosContextActions = memo((props) => {
  return (
    <Stack justifyContent="center" sx={{ height: "40px" }}>
      <Stack direction="row" alignItems="center">
        <Stack direction="row" spacing={1.5}>
          <Button
            disabled={props.disabled}
            variant="contained"
            color="error"
            startIcon={<Icon iconName="delete" size={16} />}
            size="small"
            sx={{ px: 2 }}
          >
            Excluir
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
});

ArquivosContextActions.propTypes = {
  disabled: PropTypes.bool,
  onUploadClick: PropTypes.func,
};

export default ArquivosContextActions;
